<div class="main"><div class="search" :style="{width:props.searchWidth}"><a-input-search placeholder="搜索关键字" @search="onSearch"></a-input-search></div></div>